import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface MacroIndicator {
  indicator_name: string;
  value: number;
  change_percent: number | null;
  previous_value: number | null;
  source: string;
  updated_at: string;
}

export function useMacroIndicators() {
  return useQuery({
    queryKey: ['macro-indicators'],
    queryFn: async (): Promise<MacroIndicator[]> => {
      const { data, error } = await supabase
        .from('macro_indicators')
        .select('indicator_name, value, change_percent, previous_value, source, updated_at');
      if (error) throw error;
      return (data || []) as MacroIndicator[];
    },
    refetchInterval: 60000,
    staleTime: 30000,
  });
}
